// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import EndUserConstants from 'constants/EndUserConstants'

const EndUserActions = Marty.createActionCreators({
  createEndUser(endUser, orgId) {
    return this.app.queries.EndUserQueries.createEndUserForOrgId(endUser, orgId)
  },

  updateEndUser(endUserId, endUserParams, accessToken) {
    return this.app.queries.EndUserQueries.updateEndUser(endUserId, endUserParams, accessToken)
  },

  setEndUserFromPusher(endUser, isNewEndUser) {
    return this.dispatch(EndUserConstants.SET_END_USER_FROM_PUSHER, endUser, isNewEndUser)
  },

  searchEndUser(orgId, query) {
    return this.app.queries.EndUserQueries.searchEndUser(orgId, query)
  }
})

export default EndUserActions



// WEBPACK FOOTER //
// ./src/scripts/actions/EndUserActions.js